/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_Person_HintInputs */



/**
* | output |
* | --- |
* | "Applies to your 1:1s with this person, not to group meetings they attend." |
*
* @param {Meetings_Exception_Person_HintInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_person_hint = /** @type {((inputs?: Meetings_Exception_Person_HintInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_Person_HintInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Geldt voor je 1:1's met deze persoon, niet voor groepsgesprekken waar die bij zit.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("S'applique à vos 1:1 avec cette personne, pas aux conversations de groupe où elle est présente.")
	return /** @type {LocalizedString} */ ("Applies to your 1:1s with this person, not to group meetings they attend.")
});